"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.characsNormalizer = void 0;
const mocks_json_1 = __importDefault(require("./mocks.json"));
const utils_common_to_kebap_case_1 = __importDefault(require("@gcloud-npm/utils.common.to-kebap-case"));
/**
 * normalizador del modulo MODULO_CARACTERISTIC_CARDS
 * @param {object} fields
 * @returns
 */
const characsNormalizer = (data) => {
    var _a, _b, _c;
    try {
        let res = null;
        const title = (_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.title;
        const position = (_b = data === null || data === void 0 ? void 0 : data.fields) === null || _b === void 0 ? void 0 : _b.orderPosition;
        const listadoCards = (_c = data === null || data === void 0 ? void 0 : data.fields) === null || _c === void 0 ? void 0 : _c.ListadoCaracteristicCard;
        if (listadoCards && Array.isArray(listadoCards) && listadoCards.length > 0) {
            const normalizedInfo = {};
            if (title) {
                normalizedInfo["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: title });
            }
            if (position === "top") {
                normalizedInfo.positionTop = true;
            }
            else {
                normalizedInfo.positionTop = false;
            }
            listadoCards.map((faq, index) => {
                const { fields } = faq;
                const { title, subTitle, icon, heightIcon } = fields;
                const card = {};
                if (icon) {
                    card["Glyph-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Glyph-1"]), { id: (0, utils_common_to_kebap_case_1.default)(icon) });
                }
                if (heightIcon) {
                    card["Glyph-1"].width = heightIcon;
                    card["Glyph-1"].height = heightIcon;
                }
                if (title) {
                    card["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Text-1"]), { text: title });
                }
                if (subTitle) {
                    card["Text-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Text-2"]), { text: subTitle });
                }
                const hasItems = Object.keys(card).length > 0;
                if (hasItems) {
                    normalizedInfo[`Charac-${index}`] = card;
                }
            });
            res = normalizedInfo;
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.characsNormalizer = characsNormalizer;
exports.default = exports.characsNormalizer;
//# sourceMappingURL=index.js.map